const FormResources = {

    form_data:{
        scenario:                           '',
        fte_hours:                          0,
        date:                               '',
        benefits:                           0,
        nonproductive:                      0,
        paid_break_minutes:                 0,
        updated_date:                       '',
        management_team:                    0,
        average_wage:                       0,
        total_salary:                       0,
        notes:                              '',
    },

    form_format:[
        {
            css_class:  'col-md-4',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Scenario:',
            model_name: 'scenario',
            ref:        'scenario_input',
            ref_alt:    'scenario_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-4',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'FTE Hours:',
            model_name: 'fte_hours',
            ref:        'fte_hours_input',
            ref_alt:    'fte_hours_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-4',
            type:       'date',
            maxlength:  '',
            disabled:   true,
            step:       '',
            name:       'Created On:',
            model_name: 'date',
            ref:        'date_input',
            ref_alt:    'date_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-4',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Benefits (%)',
            model_name: 'benefits',
            ref:        'benefits_input',
            ref_alt:    'benefits_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-4',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Nonproductive (%)',
            model_name: 'nonproductive',
            ref:        'nonproductive_input',
            ref_alt:    'nonproductive_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Paid Break Minutes',
            model_name: 'paid_break_minutes',
            ref:        'paid_break_minutes_input',
            ref_alt:    'paid_break_minutes_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'date',
            maxlength:  'any',
            disabled:   true,
            step:       '',
            name:       'Last Modified',
            model_name: 'updated_date',
            ref:        'updated_date_input',
            ref_alt:    'updated_date_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Management Team',
            model_name: 'management_team',
            ref:        'management_team_input',
            ref_alt:    'management_team_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Average Wage',
            model_name: 'average_wage',
            ref:        'average_wage_input',
            ref_alt:    'average_wage_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-4',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Total Salary Compensation',
            model_name: 'total_salary',
            ref:        'total_salary_input',
            ref_alt:    'total_salary_input_alt',
            required:   false,
        },
    ],

    form_format_note: [
        {
            css_class:  'col-md-12',
            type:       'textarea',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Notes:',
            model_name: 'notes',
            ref:        'notes_input',
            ref_alt:    'notes_input_alt',
            required:   false,
        },
    ]

}

export default FormResources;